import { render, staticRenderFns } from "./LkChangePwd.vue?vue&type=template&id=6c26bf3b&scoped=true&"
import script from "./LkChangePwd.vue?vue&type=script&lang=js&"
export * from "./LkChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./LkChangePwd.vue?vue&type=style&index=0&id=6c26bf3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26bf3b",
  null
  
)

export default component.exports